import React from 'react'
import BoardCreateComponent from '../../components/board/BoardCreateComponent'

const BoardCreatePage = () => {

  return (
    <>
        <BoardCreateComponent />
    </>
  )
}

export default BoardCreatePage